(window as any).global = window;
import 'zone.js/dist/zone';  // Included with Angular CLI.
